import {Box, Chip, TextField} from "@mui/material";
import {Autocomplete} from "@mui/lab";

const CompanyCreateKeywordsTag = ({company, setField}) => {

    return (
        <Box sx={{display: "flex",
            flexDirection: "column",
            alignItems: "left",
            justifyContent: "center"}}>

            <Autocomplete
                multiple
                fullWidth
                id="primary-keywords"
                sx={{mt: "16px","& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
                options={[].map((option) => option.title)}
                freeSolo
                value={company.primaryKeywords}
                onChange={(event, newValue) => {
                    setField("primaryKeywords", newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip variant="filled" label={option} {...getTagProps({ index })} />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        fullWidth
                        {...params}
                        label="Primary Keywords"
                    />
                )}
            />

            <Autocomplete
                multiple
                fullWidth
                id="secondary-keywords"
                sx={{mt: "16px", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
                options={[].map((option) => option.title)}
                freeSolo
                value={company.secondaryKeywords}
                onChange={(event, newValue) => {
                    setField("secondaryKeywords", newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip variant="filled" label={option} {...getTagProps({ index })} />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        fullWidth
                        {...params}
                        label="Secondary Keywords"
                    />
                )}
            />

            <Autocomplete
                multiple
                fullWidth
                id="industry-keywords"
                sx={{mt: "16px", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
                options={[].map((option) => option.title)}
                freeSolo
                value={company.industryKeywords}
                onChange={(event, newValue) => {
                    setField("industryKeywords", newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip variant="filled" label={option} {...getTagProps({ index })} />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        fullWidth
                        {...params}
                        label="Industry Keywords"
                    />
                )}
            />

            <Autocomplete
                multiple
                fullWidth
                id="product-keywords"
                sx={{mt: "16px", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
                options={[].map((option) => option.title)}
                freeSolo
                value={company.productKeywords}
                onChange={(event, newValue) => {
                    setField("productKeywords", newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip variant="filled" label={option} {...getTagProps({ index })} />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        fullWidth
                        {...params}
                        label="Product Keywords"
                    />
                )}
            />

            {/* New SEO Keywords field */}
            <Autocomplete
                multiple
                fullWidth
                id="seo-keywords"
                sx={{mt: "16px", "& .MuiAutocomplete-inputRoot" : {minHeight: "100px"}}}
                options={[].map((option) => option.title)}
                freeSolo
                value={company.seoKeywords || []}
                onChange={(event, newValue) => {
                    setField("seoKeywords", newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip variant="filled" label={option} {...getTagProps({ index })} />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        fullWidth
                        {...params}
                        label="SEO Keywords"
                    />
                )}
            />

            {/* New Forbidden Words/Phrases field */}
            <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={6}
                sx={{mt: "16px"}}
                label="Forbidden Words/Phrases"
                placeholder="Enter forbidden words or phrases separated by commas or new lines"
                value={company.forbiddenWords || ''}
                onChange={(event) => {
                    setField("forbiddenWords", event.target.value);
                }}
            />

            {/* New Internal Linking field */}
            <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={6}
                sx={{mt: "16px"}}
                label="Internal Linking from Articles"
                placeholder="Enter internal linking guidelines or URLs"
                value={company.internalLinking || ''}
                onChange={(event) => {
                    setField("internalLinking", event.target.value);
                }}
            />

        </Box>
    );
};

export default CompanyCreateKeywordsTag;
